/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Button, Form, Modal, Row, Tab, Tabs } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import UrlService from '../../../services/UrlService';
import { useD4Report } from './ContextAPI';
import DataTable from './DataTable';
import Loader from '../../Loader';

export default function ShowModel() {
    const { show, setShow, data, modalLoading, setShowPdf, partner, setPartner } = useD4Report();
    const axiosPrivate = useAxiosPrivate();
    const [page, setPage] = useState(0);
    const [pageLength, setPageLength] = useState(0);

    useEffect(() => {
        if (partner?.length > 0) return;
        const fetchPartner = async () => {
            try {
                const response = await axiosPrivate.get(UrlService.getAllPartnerUrl(), {
                    headers: { 'Content-Type': 'application/json' },
                });
                setPartner(response?.data?.partner_info);
            } catch (err) {
                if (!err?.response) {
                    console.log('Server Not Responding!');
                } else if (err.response?.status === 401) {
                    console.log('Unauthorized!');
                } else {
                    console.log('Partner Data Not Found!');
                }
            }
        };
        fetchPartner();
    }, []);

    useEffect(() => {
        setPageLength(data?.d4_records?.length);
        if (data?.d4_records?.length) {
            setPage(data.d4_records[0].id);
        }
    }, [data?.d4_records]);

    // Closing the Model
    const handleClose = () => {
        setShow(false);
    };

    const handlePrintPreview = () => {
        setShow(false);
        setShowPdf(true);
    };

    const exportToExcel = () => {
        if (!data?.d4_records?.length) return;

        const wb = XLSX.utils.book_new();

        const dateRange = data?.month && data?.year
            ? `${['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][data.month]} - ${data.year}`
            : `${moment(data.start_date).format('DD MMM YYYY')} - ${moment(data.end_date).format('DD MMM YYYY')}`;

        data.d4_records.forEach((category) => {
            if (!category.drug_list?.length) return;

            const totalCols = 2 + (partner?.length || 0) + 1;

            const merges = [];
            const titleRow = ['Item Name', dateRange];
            const partnerHeaderRow = ['', 'Opening Balance'];
            const subHeaderRow = ['', ''];

            partner?.forEach((p) => {
                partnerHeaderRow.push(p.name);
                subHeaderRow.push('Total Dispatch');
            });

            partnerHeaderRow.push('Total');
            subHeaderRow.push('Total Dispatch');

            merges.push({ s: { r: 0, c: 0 }, e: { r: 2, c: 0 } });
            merges.push({ s: { r: 0, c: 1 }, e: { r: 0, c: totalCols - 1 } });
            merges.push({ s: { r: 1, c: 1 }, e: { r: 2, c: 1 } });

            const rows = [titleRow, partnerHeaderRow, subHeaderRow];

            category.drug_list.forEach((drug) => {
                const row = [drug.drug_name, Number(drug.opening_balance) || 0];
                partner?.forEach((p) => {
                    const item = drug.partner_summary_data?.find(
                        (s) => s && parseInt(s.partner_id, 10) === parseInt(p.id, 10)
                    );
                    row.push(Number(item?.total_dispatch) || 0);
                });
                row.push(Number(drug.overall_dispatch) || 0);
                rows.push(row);
            });

            const ws = XLSX.utils.aoa_to_sheet(rows);
            ws['!merges'] = merges;

            [0, 1, 2].forEach((r) => {
                for (let c = 0; c < totalCols; c += 1) {
                    const addr = XLSX.utils.encode_cell({ r, c });
                    if (ws[addr]) {
                        ws[addr].s = { alignment: { horizontal: 'center', vertical: 'center' } };
                    }
                }
            });

            const colWidths = [{ wch: 30 }, { wch: 15 }];
            partner?.forEach(() => {
                colWidths.push({ wch: 22 });
            });
            colWidths.push({ wch: 22 });
            ws['!cols'] = colWidths;

            XLSX.utils.book_append_sheet(wb, ws, category.name?.slice(0, 31));
        });

        XLSX.writeFile(wb, 'D4_Global_Dispatch_Report.xlsx');
    };

    const tableDataDisplay = () =>
        data?.d4_records?.map((item) => (
            <Tab key={item.id} eventKey={item.id} title={item.name}>
                <DataTable
                    medicinData={item.drug_list}
                    partner={partner}
                    dateOrMonthRange={
                        data.month && data.year
                            ? `${
                                  data?.month == 1
                                      ? 'January'
                                      : data?.month == 2
                                      ? 'February'
                                      : data?.month == 3
                                      ? 'March'
                                      : data?.month == 4
                                      ? 'April'
                                      : data?.month == 5
                                      ? 'May'
                                      : data?.month == 6
                                      ? 'June'
                                      : data?.month == 7
                                      ? 'July'
                                      : data?.month == 8
                                      ? 'August'
                                      : data?.month == 9
                                      ? 'September'
                                      : data?.month == 10
                                      ? 'October'
                                      : data?.month == 11
                                      ? 'November'
                                      : data?.month == 12
                                      ? 'December'
                                      : ''
                              } - ${data.year}`
                            : `${moment(data.start_date).format('DD MMM YYYY')} - ${moment(
                                  data.end_date
                              ).format('DD MMM YYYY')}`
                    }
                />
            </Tab>
        ));

    return (
        <Modal className="modalWidth80" show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>D4 Reports: Global Dispatch Reports</Modal.Title>
                <div className="ms-auto d-flex">
                    <Button className="btn btn-dark me-2" onClick={handlePrintPreview}>
                        Print Preview
                    </Button>
                    <Button className="btn btn-success me-2" onClick={exportToExcel}>
                        Export Excel
                    </Button>
                </div>
            </Modal.Header>
            <Modal.Body className="d4report">
                {modalLoading || !data?.d4_records ? (
                    <Loader />
                ) : (
                <Form>
                    <Row>
                        <Tabs
                            activeKey={page}
                            transition={false}
                            id="noanim-tab-example"
                            className="mb-3 d4report"
                            // eslint-disable-next-line radix
                            onSelect={(k) => setPage(parseInt(k))}
                        >
                            {tableDataDisplay()}
                        </Tabs>
                    </Row>

                    <Modal.Footer className="borderTop0 pe-0">
                        <Button className="btnCancel" variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button
                            className="btnInfo me-2 ms-2"
                            variant="primary"
                            style={{ minWidth: '6rem' }}
                            disabled={page === 0}
                            onClick={() => {
                                setPage((currPage) => currPage - 1);
                            }}
                        >
                            Prev
                        </Button>
                        <Button
                            type="button"
                            className="btnSuccess"
                            disabled={page === pageLength}
                            variant="success"
                            style={{ minWidth: '6rem' }}
                            onClick={() => setPage((currPage) => currPage + 1)}
                        >
                            Next
                        </Button>
                    </Modal.Footer>
                </Form>
                )}
            </Modal.Body>
        </Modal>
    );
}